var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse-transition__wrapper",style:(_vm.dynamicWrapperStyle)},[_c('div',{ref:"slotWrapper",staticClass:"collapse-transition__height-observer",attrs:{"data-ref":_vm.$options.consts.REF}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }